import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumberToIterablePipe } from './pipes/number-to-iterable.pipe';
import { PersonFullNamePipe } from './pipes/person-full-name.pipe';
import { LinkButtonComponent } from './components/link-button/link-button.component';
import { ButtonComponent } from './components/button/button.component';
import { IconComponent } from './components/icon/icon.component';
import { MatButtonModule, MatIconModule, MatTooltipModule } from '@angular/material';
import { HintComponent } from './components/hint/hint.component';
import { FormatPhonePipe } from './pipes/format-phone.pipe';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';

@NgModule({
  declarations: [
    NumberToIterablePipe,
    PersonFullNamePipe,
    LinkButtonComponent,
    ButtonComponent,
    IconComponent,
    HintComponent,
    FormatPhonePipe,
    SanitizeHtmlPipe,
  ],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  exports: [
    CommonModule,
    PersonFullNamePipe,
    NumberToIterablePipe,
    LinkButtonComponent,
    ButtonComponent,
    IconComponent,
    HintComponent,
    FormatPhonePipe,
    SanitizeHtmlPipe,
  ],
})
export class SharedModule {}
